import { fieldLabel, statusLabel, permissionLabel } from './i18n';
const internal = new Set([
  'id',
  'workspaceId',
  'version',
  'key',
  'taskKey',
  'sourceTaskKey',
  'schemaVersion',
  'createdByAccountId',
  'allowedActions',
]);
export function StructuredData({ value, label }: { value: unknown; label?: string }) {
  if (value === null || value === undefined) return null;
  if (Array.isArray(value))
    return (
      <div className="content-blocks">
        {value.map((item, index) => (
          <StructuredData
            key={index}
            value={item}
            label={
              typeof item === 'object' && item
                ? String(
                    (item as Record<string, unknown>).title ||
                      (item as Record<string, unknown>).name ||
                      `${label || 'Раздел'} ${index + 1}`,
                  )
                : undefined
            }
          />
        ))}
      </div>
    );
  if (typeof value === 'object')
    return (
      <section className="panel content-block">
        {label && <h3>{label}</h3>}
        <dl>
          {Object.entries(value)
            .filter(
              ([key, current]) =>
                !internal.has(key) &&
                current !== null &&
                current !== undefined &&
                !(typeof current === 'string' && /^[0-9a-f-]{36}$/i.test(current)),
            )
            .map(([key, current]) =>
              typeof current === 'object' ? (
                <div className="content-nested" key={key}>
                  <dt>{fieldLabel(key)}</dt>
                  <dd>
                    <StructuredData value={current} />
                  </dd>
                </div>
              ) : (
                <div key={key}>
                  <dt>{fieldLabel(key)}</dt>
                  <dd>
                    {key === 'permission'
                      ? permissionLabel(String(current))
                      : ['weight', 'DELIVERABLES', 'SKILLS', 'VALUES'].includes(key) &&
                          typeof current === 'number'
                        ? `${current / 100}%`
                        : typeof current === 'boolean'
                          ? current
                            ? 'Да'
                            : 'Нет'
                          : typeof current === 'string' && /^[A-Z_]+$/.test(current)
                            ? statusLabel(current)
                            : String(current)}
                  </dd>
                </div>
              ),
            )}
        </dl>
      </section>
    );
  if (typeof value === 'string' && /^[0-9a-f-]{36}$/i.test(value)) return null;
  return <p className="content-value">{String(value)}</p>;
}
